<nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
  <ol class="breadcrumb border-0 p-0">
    <li class="breadcrumb-item" aria-current="page">
      <a class=" text-decoration-none">
        <fa-icon icon="circle-info"></fa-icon>
        <span jhiTranslate="global.menu.infos.main">institutions</span>
      </a>
    </li>
    <li class="breadcrumb-item active text-secondary" aria-current="page">
      Programm
    </li>
  </ol>
</nav>

<div class="row mt-4">
  <div class="col-lg-8 mb-3">
    <h4 class="text-primary">Wer sind wir, was tun wir</h4>
    <p>Ein Unternehmen, projektiert, realisiert und geführt durch Isabelle Kölbl, eine der ersten Schweizer
      Sexualbegleiterinnen, ausgebildet von der renommierten Psychologin und Behindertenaktivistin <a
        href="https://www.hslu.ch/de-ch/soziale-arbeit/agenda/fachtagungen-kongresse/archiv/sexualaufklaerung/die-wuerde-ist-in-allen-lebensbereichen-unantastbar/"
        target="_blank">Dr.
        phil. Aiha Zemp</a>,
      Fachstelle für Behinderung und Sexualität. Frau Kölbl hat im Jahr 2014 das Schulungskonzept für angehende
      Sexualbegleiter/innen wie auch die Plattform sexcare.ch zur Suche und Buchung von qualifizierter Sexualbegleitung
      aufgebaut. Ihre seit 2007 gesammelten Praxis Erfahrungen und deren Interaktionen mit Institutionen und
      Beauftragten
      hat sie in Form von <a href="{{baseUrl}}/institutions">Fach- und Support Angeboten</a> eingebracht. Damit
      führt Frau Kölbl das Gedankengut der im Jahr 2011
      verstorbenen Aiha Zemp fort.</p>
    <p>
      Seit 2017 unterstützt Isabelle Kölbl als Dozentin an der Fachhochschule NSWdas Modul
      <q>Sexualpädagogische Methodenvielfalt</q> und unterrichtet bei der Stiftung OdA Gesundheit im Kanton Solothurn
      SoDas zum
      Kompetenzbereich <q>Abhängigkeit, Macht und Missbrauch in der Betreuung, Sexualität</q>.
    </p>
    <div class="card p-3 text-center px-4 shadow-sm">
      <div class="user-image">
        <img src="/../../../content/images/ik_logo.png" class="rounded-circle" width="80">
      </div>
      <div class="user-content">
        <h5 class="mb-0"> Isabelle Kölbl</h5>
        <p class="mt-2">
          <q>Sex gehört zu den Grundbedürfnissen jedes Menschen. Sex ist tief in unserem Sein verankert, als
            physiologisches Bedürfnis, ohne dessen Befriedigung eine Spezies nicht überleben kann. Aber auch als
            soziales Bedürfnis, welches über die rein physische Ebene hinausgeht und unsere Seele und Existenz mit Nähe
            und Zuneigung zu anderen Menschen nährt. Auch Frauen und Männer mit Handicap oder sexuellen Einschränkungen
            haben diese Bedürfnisse und ein Recht, diese selbstbestimmt ausleben und befriedigen zu dürfen; sei das in
            einer Beziehung oder durch eine professionelle Dienstleistung.</q></p>
      </div>
    </div>

    <p class="mt-3">
      Das sexcare Programm bietet einen transparenten und professionellen Rahmen für sexuelle Dienstleistungen, dies
      ohne unklare Motivationen, für Frauen und Männer mit Handicap. </p>

    <p>Wir gehen noch einen Schritt weiter und differenzieren uns ganz klar von gängigen Angeboten der
      Berührerinnen:
      unsere sexcare Sexualbegleiterinnen und Sexualbegleiter bieten eine interaktive erotische Dienstleistung an und
      beschränken sich nicht auf Berührungen noch machen sie ihr Angebot von Sympathie abhängig.</p>

    <h4 class="text-primary">Leitgedanke</h4>
    <p>Mit bestmöglich strukturierter Vorarbeit den Gast, die Institutionen und Beauftragten, wie der/die
      Sexualbegleiter/in zu unterstützen und den Freiraum schaffen, um Sexualität praktisch stattfinden zu lassen, nach
      den Wünschen des Betroffenen, in der Form, dass alle Beteiligten dahinter stehen können.</p>

    <h4 class="text-primary">Ausbildung Sexualbegleitung</h4>
    <p><a href="{{baseUrl}}/info/education">Praxisbezogene Schulung</a>, frei von politischen, religiösen und
      ideologischen Auffassungen, unter Mitwirkung von
      Fachkräften, direkt Betroffenen und erfahrenen Anbieterinnen und Anbieter. Regelmässige persönliche Coaching
      Termine sind Bestandteil der Ausbildung.</p>

    <h4 class="text-primary">Medien</h4>
    <p>Spannende Einblicke in unsere Arbeit
      bieten die zahlreichen <a href="{{baseUrl}}/media">Medienbeiträge</a>, wie z.B. die beiden TV Sendungen des Schweizer Fernsehens: Isabelle Kölbl
      als Gast in der Talkshow von Kurt Aeschbacher und des News-Magazin 10vor10 sexcare Ausbildung Sexualbegleitung im
      Paraplegikerzentrum in Nottwil.</p>

  </div>

  <div class="col-lg-4">
    <div class="border rounded p-3 mb-4" style="background-color: #eaeaea;">
      <div class="mt-3">
        <h4>Ihre Ansprechperson</h4>
      </div>
      <div class="align-items-center">
        <div class="w-25 h-25">
          <img
            src="/../../../content/images/ik_logo.png"
            alt=""
            class="about-img img-fluid rounded-circle"
          />
        </div>
        <p class="mt-2">
          Isabelle Kölbl, Geschäftsführerin
          <br>
          Leitung Ausbildung & Support
          <br>
          Aktive Sexualbegleitung fabs
          <br>
          <a href="mailto:info@sexcare.ch">info&#64;sexcare&#46;ch</a>
        </p>
      </div>
    </div>
  </div>
</div>
